/**
 * Which AsoebiManager tab a /asoebi/<segment> URL maps to, and back. One
 * place so App.tsx (routing) and AsoebiManager (rendering) agree.
 */
// 'deliveries' deferred: see the build plan's 'missing' list (API is live, screen is not).
export type AsoebiTab = 'overview' | 'fabrics' | 'orders' | 'assignments' | 'bundles';

export const ASOEBI_TAB_BY_VIEW: Record<string, AsoebiTab> = {
  'asoebi-fabrics': 'fabrics',
  'asoebi-orders': 'orders',
  'asoebi-bundles': 'bundles',
};

export const ASOEBI_VIEW_BY_TAB: Record<AsoebiTab, string> = {
  overview: 'asoebi',
  fabrics: 'asoebi-fabrics',
  orders: 'asoebi-orders',
  assignments: 'asoebi-assignments',
  bundles: 'asoebi-bundles',
};
